'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsPersonPinCircle = function MapsPersonPinCircle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm0 2c1.1 0 2 .9 2 2 0 1.11-.9 2-2 2s-2-.89-2-2c0-1.1.9-2 2-2zm0 10c-1.67 0-3.14-.85-4-2.15.02-1.32 2.67-2.05 4-2.05s3.98.73 4 2.05c-.86 1.3-2.33 2.15-4 2.15z' })
  );
};
MapsPersonPinCircle = (0, _pure2.default)(MapsPersonPinCircle);
MapsPersonPinCircle.displayName = 'MapsPersonPinCircle';
MapsPersonPinCircle.muiName = 'SvgIcon';

exports.default = MapsPersonPinCircle;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/maps/person-pin-circle.js
// module id = 3261
// module chunks = 0